export const CREATE_SIGNUP_USER_RESET = "CREATE_SIGNUP_USER_RESET"
export const CREATE_SIGNUP_USER_REQUEST = "CREATE_SIGNUP_USER_REQUEST"
export const CREATE_SIGNUP_USER_SUCCESS = "CREATE_SIGNUP_USER_SUCCESS"
export const CREATE_SIGNUP_USER_FAILURE = "CREATE_SIGNUP_USER_FAILURE"